import { render, staticRenderFns } from "./NotifJoinMyCommunity.vue?vue&type=template&id=1dfb834d&scoped=true"
import script from "./NotifJoinMyCommunity.vue?vue&type=script&lang=js"
export * from "./NotifJoinMyCommunity.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=1dfb834d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb834d",
  null
  
)

export default component.exports